import React from 'react';
import { COLORS } from '../../common/colors';

interface MacroBarProps {
    protein: number;
    fat: number;
    carb: number;
    sugar: number;
}

const MacroBar: React.FC<MacroBarProps> = ({ protein, fat, carb, sugar }) => {
    // TODO: think about abstraction to a separate component - see CalDistrChart2
    const proteinCalories = protein * 4;
    const fatCalories = fat * 9;
    const carbCalories = carb * 4;
    const sugarCalories = sugar * 4;

    const totalCalories = proteinCalories + fatCalories + carbCalories + sugarCalories;

    // Calculate percentages
    const proteinPercent = (proteinCalories / totalCalories) * 100;
    const fatPercent = (fatCalories / totalCalories) * 100;
    const carbPercent = (carbCalories / totalCalories) * 100;
    const sugarPercent = (sugarCalories / totalCalories) * 100;

    return (
        <div className="w-full my-2 h-1 flex">
            <div
                className="h-full"
                style={{
                    width: `${proteinPercent}%`,
                    backgroundColor: COLORS.protein,
                }}
            ></div>
            <div
                className="h-full"
                style={{
                    width: `${fatPercent}%`,
                    backgroundColor: COLORS.fat,
                }}
            ></div>
            <div
                className="h-full"
                style={{
                    width: `${carbPercent}%`,
                    backgroundColor: COLORS.carb,
                }}
            ></div>
            <div
                className="h-full"
                style={{
                    width: `${sugarPercent}%`,
                    backgroundColor: COLORS.sugar,
                }}
            ></div>
        </div>
    );
};

export default MacroBar;
